
export default {
  RECIPE_FORM_INIT: 'RECIPE_FORM_INIT',
  RECIPE_FORM_UPDATE: 'RECIPE_FORM_UPDATE',
  RECIPE_FORM_ERROR: 'RECIPE_FORM_ERROR',
  RECIPE_FORM_SUBMIT: 'RECIPE_FORM_SUBMIT'
};


// WEBPACK FOOTER //
// ./modules/recipe_form/constants/RecipeFormConstants.js